module.exports = __webpack_public_path__ + "static/media/groups.42013871.png";